import OLTileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import React, { useCallback, useEffect, useRef } from 'react';
import { MAP_EVENTS } from '../constants';
import DatasourceLayer from './DatasourceLayer';
const GenericWMSLayer = ({
  map,
  name,
  zIndex,
  layer
}) => {
  const olLayer = useRef();
  useEffect(() => {
    if (!map) {
      return;
    }
    const tileLayer = new OLTileLayer({
      projection: 'EPSG:23700',
      source: new TileWMS(layer.initialLayerData.source),
      zIndex,
      properties: {
        name
      }
    });
    map.addLayer(name, tileLayer, layer.defaultVisibility);
    tileLayer.setZIndex(zIndex);
    olLayer.current = tileLayer;
    const visibilityListener = map.addEventListener(MAP_EVENTS.visibilityChange, () => {
      tileLayer.setVisible(map.getLayerVisibility(name));
    });

    // eslint-disable-next-line consistent-return
    return () => {
      if (!map) {
        return;
      }
      map.removeEventListener(MAP_EVENTS.visibilityChange, visibilityListener);
      map.removeLayer(tileLayer);
    };
  }, [map]);
  const setSource = useCallback(source => {
    if (!olLayer.current) {
      return;
    }
    if (source === null) {
      olLayer.current.setSource(undefined);
      return;
    }
    const s = new TileWMS(source);
    olLayer.current.setSource(s);
  }, [olLayer.current]);
  if (typeof layer.source !== 'function') {
    return null;
  }
  return /*#__PURE__*/React.createElement(DatasourceLayer, {
    map: map,
    layer: layer,
    name: name,
    setSource: setSource
  });
};
export default GenericWMSLayer;